import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

/**
 * CustomSelect - Desplegable personalizado que es visible en screen sharing
 * Reemplaza los <select> nativos que no aparecen al compartir pantalla en Google Meet / Zoom
 */
const CustomSelect = ({ value, onChange, options, className = '' }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    // Cerrar al hacer clic fuera
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const selected = options.find(o => String(o.value) === String(value));

    return (
        <div ref={ref} className={`relative ${className}`} style={{ userSelect: 'none' }}>
            {/* Botón visible */}
            <button
                type="button"
                onClick={() => setOpen(!open)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-50 text-left flex items-center justify-between focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            >
                <span className="text-gray-800 text-sm">{selected ? selected.label : '— Seleccionar —'}</span>
                <ChevronDown size={16} className={`text-gray-500 transition-transform ${open ? 'rotate-180' : ''}`} />
            </button>

            {/* Lista de opciones */}
            {open && (
                <ul
                    className="absolute z-50 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-56 overflow-y-auto"
                    style={{ top: '100%', left: 0 }}
                >
                    {options.map((opt, idx) => (
                        <li
                            key={opt.value || `header-${idx}`}
                            onClick={() => { 
                                if (opt.isLabel) return;
                                onChange(opt.value); 
                                setOpen(false); 
                            }}
                            className={`px-4 py-2 text-sm transition
                                ${opt.isLabel 
                                    ? 'bg-gray-100 text-gray-500 font-bold uppercase text-[10px] tracking-wider cursor-default mt-2 first:mt-0' 
                                    : `cursor-pointer hover:bg-primary-50 hover:text-primary-700 
                                       ${String(opt.value) === String(value) ? 'bg-primary-100 font-semibold text-primary-800' : 'text-gray-800'}`
                                }`}
                        >
                            {opt.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default CustomSelect;
